import { isRouteErrorResponse, useRouteError } from 'react-router';
import { shellCopy } from '@/copy/shell';
import { Button, ButtonLink, EmptyState, Spinner, Wordmark } from '../kit';

/** Small system screens: not found, route error, splash. */

export function NotFound() {
  return (
    <EmptyState
      title={shellCopy.notFound.title}
      body={shellCopy.notFound.body}
      art="ball"
      action={
        <ButtonLink to="/" variant="primary">
          {shellCopy.notFound.action}
        </ButtonLink>
      }
    />
  );
}

export function RouteError() {
  const err = useRouteError();
  if (isRouteErrorResponse(err) && err.status === 404) return <NotFound />;
  console.error('[route] crashed', err);
  return (
    <div className="mx-auto max-w-md p-6 pt-16">
      <EmptyState
        title={shellCopy.routeError.title}
        body={shellCopy.routeError.body}
        art="whistle"
        action={
          <Button variant="primary" onClick={() => window.location.reload()}>
            {shellCopy.routeError.action}
          </Button>
        }
      />
    </div>
  );
}

/** Stack logo on the lilac ground inside the thick ink frame, while the cache restores. */
export function Splash() {
  return (
    <main className="grid min-h-dvh place-items-center bg-lilac">
      <div className="tts-frame" aria-hidden="true" />
      <div className="flex flex-col items-center gap-8">
        <Wordmark variant="stack" width="min(70vw, 300px)" label="TTS Basketball" />
        <Spinner label={shellCopy.splash} />
      </div>
    </main>
  );
}
